import $ from 'jquery';
import User from '../api/user';
import WebshopUser from '../api/webshopuser';
import InlineInput from '../modules/inline-input';
import delegateListener from '../modules/delegate-listener';
import Multiselect from '@crasman/multiselect';

/**
 * Edit Users view
 */

class EditUser {
  constructor(options = {}) {
    const defaults = {
      enabledPages: '.page--edit-users',
      erpUsersTable: '#edit-user-erp',
      webshopUsersTable: '#edit-user-webshop',
      ssnBtn: '.js-check-ssn',
      ssnBtnClear: '.js-check-ssn-clear',
      ssnForm: document.querySelector('.check-ssn-form'),
    };
    Object.assign(this, defaults, options);

    this.multiselectSettings = Object.assign({
      buttonElement: {
        textContent: '- Valitse -',
        //showPlaceholder: false
      },
      listElement: { size: 12 }
    }, options.multiselectSettings);

    if(document.documentElement.querySelector(this.enabledPages)) {
      this.bindListeners();
    }
  }

  bindListeners() {
    if (document.querySelector(this.erpUsersTable)) {
      this._boundErpChangeHandler = this.handleErpChange.bind(this);
      document.body.querySelector(this.erpUsersTable).addEventListener('change', this._boundErpChangeHandler);
      this._initMultiselects();
      // initialize new multiselects when dataTable gets redrawn:
      $('.datatable#edit-user-erp')
        .on('draw.dt', e => this._initMultiselects(e.currentTarget));      
    }

    if (document.querySelector(this.webshopUsersTable)) {
      this._boundWebshopChangeHandler = this.handleWebshopChange.bind(this);
      document.body.querySelector(this.webshopUsersTable).addEventListener('change', this._boundWebshopChangeHandler);

      const boundSSNhandler = this._handleSSNcheck.bind(this);
      document.body.addEventListener('click', delegateListener(this.ssnBtn, boundSSNhandler));

      const boundSSNclearHandler = this._handleSSNclear.bind(this);
      document.body.addEventListener('click', delegateListener(this.ssnBtnClear, boundSSNclearHandler));
    }

    // Initialize inline inputs for editing user's info
    new InlineInput({
      saveAction: (source, value) => {
        const table = source.closest('.datatable');
        const cell = source.closest('td');
        $(table).dataTable().api().cells(cell).invalidate().draw()
      }
    }).init();
  }

  /**
   * Instantiates @crasman/multiselect for every non-initialized
   * (= not hidden) <select> with the [multiple] attribute.
   *
   * @param {HTMLElement} [container] - Parent element for the select[multiple]s. Defaults to `document`
   */
  _initMultiselects(container = document) {
    container.querySelectorAll('select[multiple]:not([hidden])')
      .forEach(select => new Multiselect(select, this.multiselectSettings));
  }

  _formatInputData(input) {
    let data = {};
    if(input.type === 'checkbox') {
      data[input.dataset.field] = input.checked ? '1' : '0';
    } else if(input.type === 'text') {
      data[input.dataset.field] = input.value;
    } else if(input.tagName === 'SELECT') {
      if(input.multiple) {
        data[input.dataset.field] = Array.from(input.selectedOptions)
          .map(option => option.value).join(',');
      } else {
        data[input.dataset.field] = input.options[input.selectedIndex].value;
      }
    }
    return this._replaceNullValues(data);
  }

  /**
   * 'change' event handler for ERP users
   * @param {Event} event - The initiating event
   */
  handleErpChange(event) {
    const input = event.target;
    const data = this._formatInputData(input);

    const pid = input.closest('[data-user-pid]').dataset.userPid;
    const user = new User(input.closest('[data-user-email]').dataset.userEmail);

    user.patch(data, pid);
  }

  /**
   * 'change' event handler for webshop users
   * @param {Event} event - The initiating event
   */
  handleWebshopChange(event) {
    const input = event.target;
    const data = this._formatInputData(input);

    const pid = input.closest('[data-webshopuser-pid]').dataset.webshopuserPid;
    const wsUser = new WebshopUser(pid);

    wsUser.patch(data);
  }

  /**
   * Populates user pid to check SSN form
   *
   * @param {Event} event - The initiating event
   */
  _handleSSNcheck(event) {
    const userPid = event.target.dataset.user;

    if(userPid && this.ssnForm) {
      this.ssnForm.user.value = userPid;
    }
  }

  /**
   * Clears the check SSN form on modal close
   *
   */
  _handleSSNclear() {
    this.ssnForm.user.value = '';
    this.ssnForm.reset();

    const message = this.ssnForm.querySelector('.message');
    message.classList.remove('message--success', 'message--error');
    message.innerText = '';
  }

  /**
   * Converts "null" (String) into null (Object) in order to properly clear field values
   * @param {Object} data - The data to process
   * @returns {Object} - The mutated data object
   */
  _replaceNullValues(data) {
    Object.entries(data).forEach((entry, index) => {
      if(entry[1] === 'null') {
        data[entry[0]] = null;
      }
    });

    return data;
  }
}

export default EditUser;
